import React, { SVGProps } from 'react';

function DisabledUserIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="1" y="1" width="18" height="18" rx="9" fill="#BABBC0" />
      <rect x="1" y="1" width="18" height="18" rx="9" stroke="#FEFEFE" strokeWidth="2" />
      <mask id="mask0_3386_534" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="2" y="2" width="16" height="16">
        <rect x="2" y="2" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3386_534)">
        <path d="M6.83325 10.5C6.69159 10.5 6.57286 10.4521 6.47709 10.3562C6.3812 10.2603 6.33325 10.1415 6.33325 9.99983C6.33325 9.85806 6.3812 9.73933 6.47709 9.64367C6.57286 9.54789 6.69159 9.5 6.83325 9.5H13.1666C13.3083 9.5 13.427 9.54794 13.5228 9.64383C13.6186 9.73972 13.6666 9.8585 13.6666 10.0002C13.6666 10.1419 13.6186 10.2607 13.5228 10.3563C13.427 10.4521 13.3083 10.5 13.1666 10.5H6.83325Z" fill="#FEFEFE" stroke="#FEFEFE" strokeWidth="0.5" />
      </g>
    </svg>
  );
}

export default DisabledUserIcon;
